import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row} from 'react-bootstrap';
import { CompilaQuestionarioKpis } from './CompilaQuestionarioKpis.js';

import Flex from 'components/common/Flex';

export const CompilaQuestionarioAzioni = (props) => {
  return (<>{
    props.azioni.map((azione => azione.enabled ? 
      <Card key={azione.item}  style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
            <Row className="g-0 align-items-center" style={{margin:"1%"}} >
              <Col sm="12">
                <Flex alignItems="center">
                  <h5 className="text-primary mb-0" style={{marginBottom:"3%"}}><span className="text-info fw-medium">Azione {azione.item} - {azione.codiceCsvc} :</span>&nbsp;&nbsp;&nbsp; <strong>{azione.descrizione}</strong></h5>
                </Flex>
              </Col>
            </Row>
          </Card.Title>
          <Card.Text>
            <CompilaQuestionarioKpis kpis={azione.kpis} />
          </Card.Text>
        </Card.Body>
      </Card>
    : <></> 
    ))
  }</>);
};

CompilaQuestionarioAzioni.propTypes = {
  azioni: PropTypes.array.isRequired
};

/*               
              <Col md="auto" className="mb-3 mb-md-0">
                <Button variant={'primary'}>
                  Modifica Azione
                </Button>                
              </Col>
*/
